<template>
  <div class="gift_detail">
    <van-image class="logo" :src="subject.bigLogoImg" radius="8px" show-error show-loading />
    <div class="title">{{ subject.title }}</div>
    <div class="desc">{{ subject.desc }}</div>
    <div class="price">原价：¥ {{ subject.fullPrice }}</div>

    <van-divider class="divider">赠言</van-divider>
    <div class="message">赠吾友，请你把这最诚挚的祝福带在身边</div>
    <van-divider class="divider" />

    <div class="button" @click="sendGift">赠好友</div>

    <div class="tab-contents">
      <div class="tab-content">
        <div v-html="subject.content"></div>
      </div>
      <div class="tab-content">
        <div v-html="subject.indexContent"></div>
      </div>
    </div>
    <div class="popup" v-if="isShowShare" @click="isShowShare=false">
      <div class="share" @click.stop>
        <img class="arrow" :src="require('@/assets/images/share_arrow.png')" alt="">
        <div class="content">
          <div class="share_title">你的心意，已经打包</div>
          <div class="share_desc">点击右上角，分享给好友来领取</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSubjectInfo } from './query.gql'
export default {
  name: 'GiftDetail',
  components: {
  },
  data() {
    return {
      isShowShare: false,
      user: {},
      subject: {}
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.loadData()
  },
  methods: {
    loadData() {
      // 请求数据
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      let id = parseInt(self.$route.query.id)
      self.$apollo.query({
        query: getSubjectInfo,
        variables: { id },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.profile
        self.subject = res.data.subject
        console.log(res.data)
        self.setShare()
        self.$toast.clear()
      }).catch(err => {
        console.error('page：gift/detail。请求getSubjectInfo报错', err)
        self.$toast.clear()
        self.$toast.fail('加载数据出错')
      })
    },
    setShare() {
      const self = this
      let id = parseInt(self.$route.query.id)
      // 设置分享
      self.wechatShare({
        title: `你的朋友【${self.user.nickname}】送了一门优质好课给你`,
        imgUrl: self.subject.smallLogoImg,
        desc: `${self.subject.shareContent}`,
        link: `${window.location.origin}/?#/gift/receive?id=${id}&invitationCode=${self.user.invitationCode}`
      })
    },
    sendGift() {
      this.isShowShare = true
    }
  }
}
</script>
<style lang="scss">
  .gift_detail{
    .logo {
      width: calc(100% - 64px);
      margin: 16px 32px 8px 32px;
    }
    .title {
      padding: 0px 32px 0px 32px;
      text-align: center;
      color: black;
      font-size: 16px;
      font-weight: 600;
    }
    .desc{
      line-height: 2em;
      font-size: 14px;
      color: #666;
      text-align: center;
    }
    .price {
      text-align: center;
      color: #FF3D00;
      margin-top: 16px;
      font-size: 18px;
      font-weight: 600;
      text-decoration: line-through;
    }
    .divider {
      margin-left: 16px;
      margin-right: 16px;
    }
    .message {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
    }
    .button {
      margin: 32px auto;
      width: 50%;
      background: #FFCC09;
      line-height: 50px;
      color: #B93600;
      font-weight: 600;
      text-align: center;
      border-radius: 30px;
      box-shadow: 0px 0px 10px #CCCCCC;
    }
    // 课程详情
    .tab-contents {
      padding-top: 16px;
      background: #fff;
      .tab-content {
        width: 100%;
        img {
          width: 100%;
        }
        .messageImgBox{
          position: relative;
          .message_item_box{
            position: absolute;
            left: 0;
            top: 0;
            min-width: 300rpx;
            padding: 70px 37.5px 45px;
            .message_title_img{
              width: 242.5px;
              height: auto;
              position: absolute;
              left: 0;
              right: 0;
              top: 5px;
              margin: 0 auto;
            }
            .message_item{
              display: flex;
              padding: 10px 0 20px;
              border-bottom: 1px solid #be8224;
              .message_user_img{
                width: 40px;
                height: 40px;
                border-radius: 20px;
                overflow: hidden;
                margin-right: 16px;
              }
              .message_text{
                flex: 1;
                font-size: 13px;
                .message_title{
                  color: #474747;

                  margin-bottom: 8px;
                }
                .message_desc{
                  color: #642408;
                }
              }
            }
          }
        }
      }
    }

    // 分享
    .popup {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.80);
      text-align: center;
      top: 0;
      left: 0;
      z-index: 3000;
      .share {
        width: 100%;
        position: relative;
        .arrow {
          position: absolute;
          top: 20px;
          right: 50px;
          width: 72px;
          height: 95px;
        }
        .content {
          position: absolute;
          top: 115px;
          right: 70px;
          .share_title {
            color: #FEECE1;
            font-size: 18px;
            font-weight: 600;
            text-align: left;
          }
          .share_desc {
            margin-top: 8px;
            color: #AE7D61;
            font-size: 14px;
            font-weight: 600;
            text-align: left;
          }
        }
      }
    }
  }
</style>
